import type { IconData } from '@stacksjs/iconify-core'

export const otherUiTarget: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4.25 8A3.75 3.75 0 0 1 8 4.25v2.5A1.25 1.25 0 1 0 9.25 8h2.5a3.75 3.75 0 1 1-7.5 0\"/><path fill=\"currentColor\" d=\"m9.25 8l2-2H13l3-3h-3V0l-3 3v1.75l-2 2c.69 0 1.25.56 1.25 1.25\"/><path fill=\"currentColor\" d=\"m13.25 8l-.001-.127l2.357-2.358a8 8 0 1 1-5.12-5.121L8.127 2.752L8 2.75A5.25 5.25 0 1 0 13.25 8\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiTarget
